var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E7E7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4645 27.4645C17.4021 26.5268 18.6739 26 20 26H28C29.3261 26 30.5979 26.5268 31.5355 27.4645C32.4732 28.4021 33 29.6739 33 31V33C33 33.5523 32.5523 34 32 34C31.4477 34 31 33.5523 31 33V31C31 30.2044 30.6839 29.4413 30.1213 28.8787C29.5587 28.3161 28.7956 28 28 28H20C19.2044 28 18.4413 28.3161 17.8787 28.8787C17.3161 29.4413 17 30.2044 17 31V33C17 33.5523 16.5523 34 16 34C15.4477 34 15 33.5523 15 33V31C15 29.6739 15.5268 28.4021 16.4645 27.4645Z",
    fill: "#270058"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 16C22.3431 16 21 17.3431 21 19C21 20.6569 22.3431 22 24 22C25.6569 22 27 20.6569 27 19C27 17.3431 25.6569 16 24 16ZM19 19C19 16.2386 21.2386 14 24 14C26.7614 14 29 16.2386 29 19C29 21.7614 26.7614 24 24 24C21.2386 24 19 21.7614 19 19Z",
    fill: "#270058"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.35ec657cb239b1aa227d91ea20517b65.svg";
export { ForwardRef as ReactComponent };